import {
   postRequest,
} from "@/utils/api";

// 查询运营商列表
export function listOperator(params) {
   return postRequest('/api/coo/operator/list', params)
}

// 查询运营商详情
export function getOperator(id) {
   return postRequest('/api/coo/operator/get', { id })
}

// 新增运营商
export function addOperator(data) {
   return postRequest('/api/coo/operator/add', data)
}

// 修改运营商
export function updateOperator(data) {
   return postRequest('/api/coo/operator/update', data)
}

// 删除运营商
export function delOperator(id) {
   return postRequest('/api/coo/operator/delete', { id })
}
